<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue';
import LocaleInitializer from './LocaleInitializer.vue';
import CircleSpinner from './CircleSpinner.vue';
import { setWidth } from '@app/composables/useScreenWidth';

setWidth();
onMounted(() => window.addEventListener('resize', setWidth));
onUnmounted(() => window.removeEventListener('resize', setWidth));
</script>

<template>
  <Suspense>
    <LocaleInitializer>
      <p id="external-link-sr-only">{{ $t('header.opens_in_new_tab') }}</p>
      <slot></slot>
    </LocaleInitializer>
    <template #fallback>
      <div class="spinner-wrapper">
        <CircleSpinner />
      </div>
    </template>
  </Suspense>
</template>
<style lang="scss" scoped>
@import '@style/_sfc';

#external-link-sr-only {
  display: none;
}

.spinner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - #{$header_mobile}px);

  @media screen and (min-width: $bs-md) {
    height: calc(100vh - #{$header_desktop}px);
  }
}
</style>
